import { createFileRoute } from '@tanstack/react-router'
import { UnsubscribePage } from '@/components/unsubscribe/unsubscribe-page'

export const Route = createFileRoute('/unsubscribe/')({
  component: UnsubscribePage,
})
